const AuthorizationSystem = {
  namespaced: true,

  state: {
    isLoading: false,
    activeSectionName: null,
  },

  actions: {

  },

  mutations: {
    //Отмечаем, идет ли процесс оправки запроса
    toChangeLoadingFlag(state, status){
      state.isLoading = status;
    },
    //Отмечаем отображаемую секцию в попапе
    toActiveSection(state, sectionName){
      state.activeSectionName = sectionName;
    },
  },

  getters:{

  }
}

export default AuthorizationSystem;
